var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      staticStyle: { width: "auto", "min-height": "70vh" },
    },
    [
      _vm._m(0),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c(
              "b-field",
              { attrs: { label: "Serial number(s)" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.serialBuffer,
                    callback: function ($$v) {
                      _vm.serialBuffer = $$v
                    },
                    expression: "serialBuffer",
                  },
                }),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c("b-button", {
                      attrs: { "icon-left": "arrow-down" },
                      on: { click: _vm.saveNumber },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "No serial number" } },
              [
                _c("b-input", {
                  attrs: { type: "number", min: "0" },
                  model: {
                    value: _vm.noSerialBuffer,
                    callback: function ($$v) {
                      _vm.noSerialBuffer = $$v
                    },
                    expression: "noSerialBuffer",
                  },
                }),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c("b-button", {
                      attrs: { "icon-left": "plus" },
                      on: { click: _vm.saveNoNumber },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._l(_vm.serialArray, function (c, index) {
              return _c("div", { key: index }, [
                _c(
                  "span",
                  { staticClass: "is-flex is-align-items-center" },
                  [
                    _c("div", { staticClass: "mr-2" }, [
                      _c("strong", [_vm._v(_vm._s(index + 1))]),
                      _vm._v(" : " + _vm._s(c) + " "),
                    ]),
                    _c("b-button", {
                      staticClass: "is-small",
                      attrs: { "icon-left": "xmark" },
                      on: {
                        click: function ($event) {
                          return _vm.removeNumber(index)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c(
              "b-field",
              { attrs: { label: "Type" } },
              [
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": "plant" },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  [_vm._v(" Plant ")]
                ),
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": "customer" },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  [_vm._v(" Customer ")]
                ),
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": "producer" },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  },
                  [_vm._v(" Producer ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "mb-5" }, [
          _vm.type === "plant"
            ? _c(
                "div",
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Plant" } },
                    [
                      _c("multiselect", {
                        attrs: {
                          options: _vm.$lodash.orderBy(_vm.plants, ["name"]),
                          multiple: false,
                          "close-on-select": true,
                          placeholder: "Pick plant...",
                          "custom-label": _vm.getLabel,
                          "track-by": "id",
                        },
                        model: {
                          value: _vm.assignedTo,
                          callback: function ($$v) {
                            _vm.assignedTo = $$v
                          },
                          expression: "assignedTo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.type === "customer"
            ? _c(
                "div",
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Customer" } },
                    [
                      _c("multiselect", {
                        attrs: {
                          options: _vm.customers,
                          multiple: false,
                          "close-on-select": true,
                          placeholder: "Pick customer...",
                          "custom-label": _vm.getLabel,
                          "track-by": "id",
                        },
                        model: {
                          value: _vm.assignedTo,
                          callback: function ($$v) {
                            _vm.assignedTo = $$v
                          },
                          expression: "assignedTo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.type === "producer"
            ? _c(
                "div",
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Producer" } },
                    [
                      _c("multiselect", {
                        attrs: {
                          options: _vm.$lodash.orderBy(_vm.plants, ["name"]),
                          multiple: false,
                          "close-on-select": true,
                          placeholder: "Pick producer...",
                          "custom-label": _vm.getLabel,
                          "track-by": "id",
                        },
                        model: {
                          value: _vm.assignedTo,
                          callback: function ($$v) {
                            _vm.assignedTo = $$v
                          },
                          expression: "assignedTo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm.codeGenerated
          ? _c(
              "div",
              { staticStyle: { "min-height": "150px" } },
              _vm._l(_vm.registrationCodes, function (c, index) {
                return _c("p", { key: c }, [
                  _vm._v(" " + _vm._s(index + 1) + " registration code: "),
                  _c("strong", [_vm._v(_vm._s(c))]),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          { staticClass: "buttons ml-auto" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-info",
                  disabled:
                    !_vm.type || !_vm.assignedTo || _vm.serialArray.length == 0,
                },
                on: { click: _vm.generateCode },
              },
              [_vm._v(" Generate code(s) ")]
            ),
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-primary",
                  loading: _vm.isLoading,
                  disabled: _vm.registrationCodes.length == 0,
                },
                on: { click: _vm.submit },
              },
              [_vm._v(" Submit ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Batch add new devices "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }